export default __webpack_public_path__ + "static/media/member.4a333105.svg";